/* KARMA kep-nagyito (lightbox) a PDP-hez.
   Natív <dialog>: beepitett fokusz-csapda + ESC-zaras (nem sajat kezi megoldas).
   Kovetelmenyek (Web Interface Guidelines):
   - overscroll-behavior: contain  -> a hatterlap nem gorog a nagyito alatt
   - lathato focus-allapot, semmi outline:none potlas nelkul
   - billentyu: <- -> lapozas, ESC zaras (natív)
   - touch-action: manipulation; prefers-reduced-motion tiszteletben
   - a nagyito a nyitaskor aktiv kepnel indul, es visszaadja a fokuszt */
(function () {
  /* a scriptet a fo szekcio ES a lifestyle-sav is behuzza -> csak egyszer fusson */
  if (window.__karmaLightbox) return;
  window.__karmaLightbox = true;

  var dlg, img, cap, prevBtn, nextBtn, sorozat = [], idx = 0, honnan = null;

  function letrehoz() {
    dlg = document.createElement('dialog');
    dlg.className = 'karma-lb';
    dlg.setAttribute('aria-label', 'Kép nagyítva');
    dlg.innerHTML =
      '<button type="button" class="karma-lb__close" aria-label="Bezárás">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">' +
        '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="karma-lb__nav karma-lb__nav--prev" aria-label="Előző kép">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" aria-hidden="true">' +
        '<path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<div class="karma-lb__stage"><img class="karma-lb__img" alt=""></div>' +
      '<button type="button" class="karma-lb__nav karma-lb__nav--next" aria-label="Következő kép">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" aria-hidden="true">' +
        '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<p class="karma-lb__cap" aria-live="polite"></p>';
    document.body.appendChild(dlg);
    img = dlg.querySelector('.karma-lb__img');
    cap = dlg.querySelector('.karma-lb__cap');
    prevBtn = dlg.querySelector('.karma-lb__nav--prev');
    nextBtn = dlg.querySelector('.karma-lb__nav--next');

    dlg.querySelector('.karma-lb__close').addEventListener('click', function () { dlg.close(); });
    prevBtn.addEventListener('click', function () { lep(-1); });
    nextBtn.addEventListener('click', function () { lep(1); });
    /* hatter-kattintas zar (a kep es a gombok nem) */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.classList.contains('karma-lb__stage')) dlg.close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); lep(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); lep(1); }
    });
    /* A 'close' esemenyre NEM tamaszkodunk (nem minden kornyezetben sul el megbizhatoan).
       Az `open` attributumot figyeljuk: igy ESC, bezaro gomb es hatter-kattintas utan is
       feloldjuk a gorges-zarat es visszaadjuk a fokuszt. */
    new MutationObserver(function () {
      if (!dlg.hasAttribute('open')) {
        document.documentElement.style.overflow = '';
        if (honnan && honnan.focus) honnan.focus();
      }
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }

  function mutat() {
    var f = sorozat[idx];
    img.src = f.nagy;
    img.alt = f.alt || '';
    var tobb = sorozat.length > 1;
    prevBtn.hidden = !tobb;
    nextBtn.hidden = !tobb;
    cap.textContent = tobb ? (idx + 1) + ' / ' + sorozat.length : '';
  }
  function lep(d) {
    if (sorozat.length < 2) return;
    idx = (idx + d + sorozat.length) % sorozat.length;
    mutat();
  }

  /* egy kepbol nagyfelbontasu URL (a Shopify width-parametere) */
  function nagyUrl(el) {
    var src = el.currentSrc || el.src || '';
    return src.replace(/([?&])width=\d+/, '$1width=2000');
  }

  function nyit(kepek, kezdo, kiindulo) {
    if (!dlg) letrehoz();
    sorozat = kepek;
    idx = kezdo;
    honnan = kiindulo;
    mutat();
    /* ha valamiert mar nyitva van, csak a kepet frissitjuk - a showModal() ilyenkor
       hibat dobna, es a gorges-zar beragadna */
    if (dlg.open) return;
    try {
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';   /* hatterlap-gorges zar */
    } catch (e) {
      document.documentElement.style.overflow = '';         /* sose ragadjon be */
    }
  }

  /* --- bekotes: termekfoto-sav (csak a LATHATO, azaz szinre szurt kepek) --- */
  var gal = document.querySelector('[data-karma-gal]');
  if (gal) {
    gal.addEventListener('click', function (e) {
      var kep = e.target.closest && e.target.closest('.karma-gal__img');
      if (!kep) return;
      var lathato = [].slice.call(gal.querySelectorAll('[data-gslide]'))
        .filter(function (s) { return !s.hidden; })
        .map(function (s) { return s.querySelector('img'); });
      var i = lathato.indexOf(kep);
      if (i < 0) return;
      nyit(lathato.map(function (x) { return { nagy: nagyUrl(x), alt: x.alt }; }), i, kep);
    });
  }

  /* --- bekotes: lifestyle-sav --- */
  var ls = document.querySelector('[data-karma-ls]');
  if (ls) {
    ls.addEventListener('click', function (e) {
      var kep = e.target.closest && e.target.closest('.karma-ls__img');
      if (!kep) return;
      var mind = [].slice.call(ls.querySelectorAll('.karma-ls__img'));
      var i = mind.indexOf(kep);
      nyit(mind.map(function (x) { return { nagy: nagyUrl(x), alt: x.alt }; }), i, kep);
    });
  }
})();
